import { gql } from '@src/lib/gql'

export const CANCEL_ADVISOR_PAYOUT = gql`
  mutation CancelAdvisorPayout($input: CancelAdvisorPayoutInput!) {
    cancelAdvisorPayout(input: $input) {
      advisorPayout {
        id
        advisorPayoutId
        amountUsd
        statusKey
        status {
          id
          key
          title
        }
        failureReason
        stripeTransferId
        requestedAt
        completedAt
        failedAt
        approvedAt
        rejectedAt
        rejectionReason
        canceledAt
        canceledByUserId
        approvedByUserId
        rejectedByUserId
        canCurrentUserReview
        canCurrentUserCancel
        approvedByUser {
          id
          userId
          fullName
          displayName
        }
        rejectedByUser {
          id
          userId
          fullName
          displayName
        }
      }
    }
  }
`
